import { CRM } from "@/components/atomic-crm/root/CRM";
import { createNeonCrmProviders } from "@/components/atomic-crm/providers/neon/createProviders";

const getNeonProviders = () => {
  if (import.meta.env.VITE_CRM_BACKEND !== "neon") {
    return null;
  }

  const authUrl = import.meta.env.VITE_NEON_AUTH_URL;
  const dataApiUrl = import.meta.env.VITE_NEON_DATA_API_URL;
  const tenantId = import.meta.env.VITE_NEON_TENANT_ID || "30.2";

  if (!authUrl || !dataApiUrl) {
    throw new Error(
      "Neon CRM requires VITE_NEON_AUTH_URL and VITE_NEON_DATA_API_URL",
    );
  }

  return createNeonCrmProviders({ authUrl, dataApiUrl, tenantId });
};

const neonProviders = getNeonProviders();

/**
 * Application entry point
 *
 * Set VITE_CRM_BACKEND=neon in the canary to inject Neon Auth + Data API.
 * Without that flag, CRM keeps its existing default providers.
 */
const App = () =>
  neonProviders ? (
    <CRM
      authProvider={neonProviders.authProvider}
      dataProvider={neonProviders.dataProvider}
    />
  ) : (
    <CRM />
  );

export default App;
